export class UserSessionRequest {
    Name: string;
    UserEmail: string;
    SessionId?: string;
    CollectionId?: number | null;

    constructor(name: string, userEmail: string, sessionId?: string, collectionId?: number | null) {
        this.Name = name;
        this.UserEmail = userEmail;
        this.SessionId = sessionId;
        this.CollectionId = collectionId;
    }
}